// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.organization', {
    url: '/organization',
    controller: 'OrganizationConfigurationController as vm',
    templateUrl: 'main/configuration/organization/organization.tpl.html',
    data: { pageTitle: 'Organization' },
  });
};

class OrganizationConfigurationController {
  constructor($scope, currentOrganization) {
    'ngInject';

    this.$scope = $scope;
    this.original = currentOrganization.config;
    this.organization = currentOrganization;
  }
}

angular
  .module('configuration.organization', [])
  .config(config)
  .controller(
    'OrganizationConfigurationController',
    OrganizationConfigurationController,
  );
